import { useQuery } from "@tanstack/react-query";

import { QueryKey } from "@/constants/shared";
import { checkGeoCompliance } from "@/network/api";

export const useCompliance = () => {
  const { data, isPending, error } = useQuery({
    queryKey: [QueryKey.Compliance],
    queryFn: async () => {
      const response = await checkGeoCompliance();
      return response;
    },
  });

  return {
    geoCompliance: {
      ...data,
    },
    isPendingGeoCompliance: isPending,
    geoComplianceError: error,
  };
};
